import React from 'react';
import { useTranslation } from 'react-i18next';
import { useClerk } from '@clerk/clerk-react';
import CgRadixButton from 'modules/Common/ui/CgRadixButton';

// Rendered BEFORE OrgBoundary (verifier-firm-foundation phase 2): a removed member who follows a
// new invite is signed in but usually has no org, and the org tree would send them to onboarding.
const VerifierBlockedPage = () => {
  const { t } = useTranslation('app');
  const { signOut } = useClerk();
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6">
      <div className="max-w-md rounded-xl bg-white p-6 text-center shadow-sm">
        <h1 className="m-0 mb-2 text-lg font-semibold text-slate-900">
          {t('verifier.blocked.title', 'Your access was removed')}
        </h1>
        <p className="m-0 mb-4 text-sm text-slate-600">
          {t(
            'verifier.blocked.body',
            'An administrator of this verifier firm removed your access. Ask them to unblock you if this is a mistake.',
          )}
        </p>
        <CgRadixButton
          variant="secondary"
          label={t('verifier.blocked.signOut', 'Sign out')}
          onClick={() => signOut({ redirectUrl: '/sign-in' })}
        />
      </div>
    </div>
  );
};

export default VerifierBlockedPage;
